import { ToggleButtonGroup, styled } from "@mui/material";

export const StyledToggleButtonGroup = styled(ToggleButtonGroup)(
    ({ theme }) => ({
        backgroundColor: theme.palette.grey[100],
        borderRadius: "8px",
        padding: "3px",
        gap: "2px",
        border: "none",
        "& .MuiToggleButtonGroup-grouped": {
            border: "none !important",
            borderRadius: "6px !important",
            margin: 0,
        },
        "& .MuiToggleButton-root": {
            padding: "5px 14px",
            fontSize: "0.75rem",
            fontWeight: 500,
            textTransform: "none",
            color: theme.palette.text.secondary,
            border: "none",
            borderRadius: "6px",
            transition: "all 0.15s ease",
            lineHeight: 1.5,
            "&:hover": {
                backgroundColor: theme.palette.grey[200],
                color: theme.palette.text.primary,
            },
            "&.Mui-selected": {
                backgroundColor: theme.palette.background.paper,
                color: theme.palette.text.primary,
                fontWeight: 600,
                boxShadow:
                    "0 1px 3px 0 rgba(0, 0, 0, 0.08), 0 1px 1px 0 rgba(0, 0, 0, 0.04)",
                "&:hover": {
                    backgroundColor: theme.palette.background.paper,
                },
            },
        },
    })
);
